import 'css-chunksrc/client/common/secondaryCriteriaForm/resourceForm/styles.scss';export default {
  "listForm": "_listForm_9wgnk_1",
  "input": "_input_9wgnk_5",
  "icon": "_icon_9wgnk_13",
  "open": "_open_9wgnk_24",
  "readOnly": "_readOnly_9wgnk_28",
  "listRoot": "_listRoot_9wgnk_35",
  "list": "_list_9wgnk_1",
  "name": "_name_9wgnk_47",
  "item": "_item_9wgnk_51",
  "selected": "_selected_9wgnk_70",
  "header": "_header_9wgnk_79",
  "textInput": "_textInput_9wgnk_84",
  "main": "_main_9wgnk_97",
  "allocation": "_allocation_9wgnk_105",
  "infoBubble": "_infoBubble_9wgnk_115",
  "slideIn": "_slideIn_9wgnk_1",
  "picture": "_picture_9wgnk_121",
  "summary": "_summary_9wgnk_127",
  "menu": "_menu_9wgnk_136",
  "addAllocationIcon": "_addAllocationIcon_9wgnk_140",
  "resourcesList": "_resourcesList_9wgnk_146",
  "up": "_up_9wgnk_153",
  "down": "_down_9wgnk_158",
  "details": "_details_9wgnk_158",
  "quickAllocationMenu": "_quickAllocationMenu_9wgnk_164",
  "overlay": "_overlay_9wgnk_169"
};